import { useEffect, useRef, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
//datepicker
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
//ckeditor
import { CKEditor } from "ckeditor4-react";
import { editorConfig, SwalError } from "../../../../utils/constants";
//utils
import {
  create,
  getAll,
  getById,
  saveFile,
  update,
} from "../../../../utils/requests/dynamicReq";
import { paths } from "../../../../utils/paths";

//middleware
import moment from "moment";
import produce from "immer";
import Swal from "sweetalert2";
import Axios from "axios";
import { validate } from "./validations";
import { ROUTES } from "../../../../utils/routes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { useDelete } from "../../../../utils/hooks/useDelete";
import { useSelector } from "react-redux";
import { PdfUploader } from "../../../../components/FileUploader/PdfUploader";
registerLocale("es", es);

export const ManagePropuesta = () => {
  let { isAdmin, userRoleId } = useSelector(({ user }) => user);
  const { INVESTIGATORS, ENTIDAD_PARTICIPANTE, PROPUESTAS, CONVOCATORIAS, FINANCIADORAS } =
    paths;
  const { id } = useParams();
  const history = useHistory();
  const { deleteIt } = useDelete();

  const [isCreate, setIsCreate] = useState(false);
  //userForm
  const [investigadorParticipanteExterno, setInvestigadorParticipanteExterno] =
    useState("");
  const [acronimo, setAcronimo] = useState("");
  const [estado, setEstado] = useState("");
  const [fechaInicio, setFechaInicio] = useState(new Date());
  const [fechaSolicitud, setFechaSolicitud] = useState(new Date());
  const [observaciones, setObservaciones] = useState("");
  const [referencia, setReferencia] = useState("");
  const [resumenEs, setResumenEs] = useState("");
  const [resumenEn, setResumenEn] = useState("");
  const [resumenVa, setResumenVa] = useState("");
  const [tipo, setTipo] = useState("");
  const [entidadesParticipantes, setEntidadesParticipantes] = useState([]);
  const [chosenEntidadesParticipantes, setChosenEntidadesParticipantes] =
    useState([]);
  const [financiadora, setFinanciadora] = useState([]);
  const [chosenFinanciadoraId, setChosenFinanciadoraId] = useState([]);
  const [staffParticipantes, setStaffParticipantes] = useState([]);
  const [chosenStaffParticipante, setChosenStaffParticipantes] = useState([]);
  const [staffIps, setStaffIps] = useState([]);
  const [chosenStaffIp, setChosenStaffIps] = useState([]);
  const [gestionadoPor, setGestionadoPor] = useState("");
  const [presupuestoSolicitado, setPresupuestoSolicitado] = useState(0);
  const [documento, setDocumento] = useState();
  const [convocatorias, setConvocatorias] = useState([]);
  const [chosenConvocatoriaId, setChosenConvocatoriaId] = useState("");
  const [message, setMessage] = useState("");
  const [allowedEdit, setAllowedEdit] = useState(false);

  const isMounted = useRef(false);
  const source = Axios.CancelToken.source();

  useEffect(() => {
    isMounted.current = true;
    const { pathname } = history.location;
    pathname.includes("crear") ? loadDefaultData() : loadEditData();
    return () => {
      isMounted.current = false;
      source.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadDefaultData = async () => {
    try {
      let investigators = await getAll(INVESTIGATORS, source);
      let convocatorias = await getAll(CONVOCATORIAS, source);
      let financiadoras = await getAll(FINANCIADORAS, source);
      let entidadesParticipantes = await getAll(ENTIDAD_PARTICIPANTE, source);
      if (isMounted.current) {
        setIsCreate(true);
        setAllowedEdit(true);
        setConvocatorias(convocatorias);
        setFinanciadora(financiadoras);
        setEntidadesParticipantes(entidadesParticipantes);
        setStaffIps(investigators);
        setStaffParticipantes(investigators);
      }
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const loadEditData = async () => {
    try {
      let response = await getById(PROPUESTAS, id, source);
      isMounted.current && buildObjToLoad(response);
    } catch (error) {
      console.log("HTTP call cancelled");
    }
  };

  const buildObjToLoad = async (p) => {
    let allConvocatorias = await getAll(CONVOCATORIAS, source);
    let allFinanciadoras = await getAll(FINANCIADORAS, source);
    let allEntidadesParticipantes = await getAll(ENTIDAD_PARTICIPANTE, source);
    let allInvestigators = await getAll(INVESTIGATORS, source);

    const startDateWithOffset = new Date(p.fechaInicio);
    const startDateNoOffset = new Date(
      startDateWithOffset.getTime() -
        startDateWithOffset.getTimezoneOffset() * -60000
    );
    const endDateWithOffset = new Date(p.fechaSolicitud);
    const endDateNoOffset = new Date(
      endDateWithOffset.getTime() -
        endDateWithOffset.getTimezoneOffset() * -60000
    );

    
    

    setResumenEn(p.resumenEn);
    setResumenEs(p.resumenEs);
    setResumenVa(p.resumenVa);
    setObservaciones(p.observaciones);
    setReferencia(p.referencia);
    setInvestigadorParticipanteExterno(p.investigadorParticipanteExterno);
    setAcronimo(p.acronimo);
    setEstado(p.estado);
    setGestionadoPor(p.gestionadoPor);
    setTipo(p.tipo);
    setPresupuestoSolicitado(p.presupuestoSolicitado);
    setFechaInicio(startDateNoOffset);
    setFechaSolicitud(endDateNoOffset);
    setDocumento(p.documento);
    setConvocatorias(allConvocatorias);
    setChosenConvocatoriaId(p.convocatoria?.id);
    setFinanciadora(allFinanciadoras);
    setChosenFinanciadoraId(p.financiadoras);
    setEntidadesParticipantes(allEntidadesParticipantes);
    setChosenEntidadesParticipantes(p.entidadesParticipantes);
    setStaffIps(allInvestigators);
    setChosenStaffIps(p.staffIp);
    setStaffParticipantes(allInvestigators);
    setChosenStaffParticipantes(p.staffParticipante);
  };

  // HANDLE INVESTIGATORS

  // HANDLE  ENTIDADES PARTICIPANTES Y COORDINADORAS
  const addItem = (item, type) => {
    item = JSON.parse(item);

    if (type === "entidadesParticipantes") {
      setChosenEntidadesParticipantes((state) =>
        produce(state, (draftState) => {
          draftState?.push(item);
        })
      );
      setEntidadesParticipantes((state) =>
        produce(state, (draftState) =>
          draftState?.filter(({ id }) => id !== item.id)
        )
      );
    } else if (type === "financiadoras") {
      setChosenFinanciadoraId((state) =>
        produce(state, (draftState) => {
          draftState?.push(item);
        })
      );
      setFinanciadora((state) =>
        produce(state, (draftState) =>
          draftState?.filter(({ id }) => id !== item.id)
        )
      );
    } else if (type === "staffParticipantes") {
      setChosenStaffParticipantes((state) =>
        produce(state, (draftState) => {
          draftState?.push(item);
        })
      );
      setStaffParticipantes((state) =>
        produce(state, (draftState) =>
          draftState?.filter(({ id }) => id !== item.id)
        )
      );
    } else if (type === "staffIps") {
      setChosenStaffIps((state) =>
        produce(state, (draftState) => {
          draftState?.push(item);
        })
      );
      setStaffIps((state) =>
        produce(state, (draftState) =>
          draftState?.filter(({ id }) => id !== item.id)
        )
      );
    }
  };

  const removeItem = (item, type) => {
    if (type === "entidadesParticipantes") {
      setChosenEntidadesParticipantes((state) =>
        produce(state, (draftState) =>
          draftState.filter(({ id }) => id !== item.id)
        )
      );
      setEntidadesParticipantes((state) =>
        produce(state, (draftState) => {
          draftState.push(item);
        })
      );
    } else if (type === "financiadoras") {
      setChosenFinanciadoraId((state) =>
        produce(state, (draftState) =>
          draftState.filter(({ id }) => id !== item.id)
        )
      );
      setFinanciadora((state) =>
        produce(state, (draftState) => {
          draftState.push(item);
        })
      );
    } else if (type === "staffParticipantes") {
      setChosenStaffParticipantes((state) =>
        produce(state, (draftState) =>
          draftState.filter(({ id }) => id !== item.id)
        )
      );
      setStaffParticipantes((state) =>
        produce(state, (draftState) => {
          draftState.push(item);
        })
      );
    } else if (type === "staffIps") {
      setChosenStaffIps((state) =>
        produce(state, (draftState) =>
          draftState.filter(({ id }) => id !== item.id)
        )
      );
      setStaffIps((state) =>
        produce(state, (draftState) => {
          draftState.push(item);
        })
      );
    }
  };

  const handleSubmit = () => {
    const propuesta = build();
    const notValid = validate(propuesta);
    if (notValid) {
      setMessage(notValid);
      setTimeout(() => setMessage(""), 4000);
      return;
    }
    let question = isCreate ? "crear una" : "editar esta";
    Swal.fire({
      icon: "question",
      text: `¿Quieres ${question} propuesta?`,
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "No",
    }).then(({ isConfirmed }) => isConfirmed && handleConfirmation(propuesta));
  };

  const handleConfirmation = (propuesta) => {
    let createOrUpdate = isCreate
      ? create(PROPUESTAS, propuesta, source)
      : update(PROPUESTAS, id, propuesta, source);
    createOrUpdate
      .then(async ({ id: propuestaId }) => {
        let createOrUpdateText = isCreate ? "creado" : "editado";
        Swal.fire({
          icon: "success",
          text: `Propuesta ${createOrUpdateText} correctamente.`,
        });
        if (typeof documento !== "string") {
          const formData = new FormData();
          formData.append("document", documento);
          await saveFile(
            PROPUESTAS,
            propuestaId,
            "documento",
            formData,
            source
          );
        }
        history.push(`${ROUTES.Propuestas.all}/${propuestaId}`);
        isMounted.current && setIsCreate(false);
      })
      .catch(() => Swal.fire({ icon: "error", text: SwalError }));
  };

  const build = () => {
    const propuesta = {
      fechaInicio: moment(fechaInicio).format("YYYY-MM-DD"),
      fechaSolicitud: moment(fechaSolicitud).format("YYYY-MM-DD"),
      resumenEs,
      resumenEn,
      resumenVa,
      acronimo,
      estado,
      gestionadoPor,
      tipo,
      presupuestoSolicitado,
      investigadorParticipanteExterno,
      observaciones,
      referencia,
      financiadoraIds: chosenFinanciadoraId?.map((ec) => ec.id),
      entidadParticipanteIds: chosenEntidadesParticipantes.map((ep) => ep.id),
      staffParticipanteIds: chosenStaffParticipante.map((sp) => sp.id),
      staffIpIds: chosenStaffIp.map((si) => si.id),
      convocatoriaId: +chosenConvocatoriaId,
    };
    return propuesta;
  };

  const editDeleteButtons = () => {
    if (isCreate) {
      return (
        <button className="baseBtn" onClick={handleSubmit}>
          Crear Propuesta
        </button>
      );
    }
    //if is update && logged user included as IP
    return (
      <>
        <button className="baseBtn" onClick={handleSubmit}>
          Guardar cambios
        </button>
        <button
          className="smallBtn btn-danger ml-1"
          onClick={() =>
            deleteIt(PROPUESTAS, id, ROUTES.Propuestas.all, source)
          }
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </>
    );
  };

  return (
    <div className="centerPage">
      {(isAdmin || userRoleId === 3 || userRoleId === 2) && (
        <div className="container-fluid p-4">
          <div className="row">
            <div className="col d-flex justify-content-between">
              <div>
                <h3>Propuesta </h3>
              </div>
              <div>{editDeleteButtons()}</div>
            </div>
          </div>
          <div className="row mt-4">
            <div className="col-12 text-center text-danger">
              <span>{message}</span>
            </div>
          </div>
          <div className=" form-row mt-2 ">
            <div className="col-6 d-flex justify-content-center">
              <PdfUploader handleFile={setDocumento} document={documento} />
            </div>
            <div className="col">
              <span>Título </span>
              <input
                type="text"
                className="form-control"
                placeholder="Título "
                value={acronimo}
                onChange={({ target: { value } }) => setAcronimo(value)}
              />
            </div>
          </div>
          <div className="form-row mt-4">
            {/* Staff Participante */}
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addItem(value, "staffParticipantes")
                }
              >
                <option value={""}>Seleccionar Participantes</option>
                {staffParticipantes?.map((s) => (
                  <option key={s.id} value={JSON.stringify(s)}>
                    {s.nombre} {s.apellidos}
                  </option>
                ))}
              </select>
              {chosenStaffParticipante?.map((s) => (
                <span
                  key={s.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3"
                  onClick={() => removeItem(s, "staffParticipantes")}
                >
                  {s.nombre} {s.apellidos} X
                </span>
              ))}
            </div>
            {/* Staff Ips*/}
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) => addItem(value, "staffIps")}
              >
                <option value={""}>Seleccionar Ips</option>
                {staffIps?.map((s) => (
                  <option key={s.id} value={JSON.stringify(s)}>
                    {s.nombre} {s.apellidos}
                  </option>
                ))}
              </select>
              {chosenStaffIp?.map((s) => (
                <span
                  key={s.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3"
                  onClick={() => removeItem(s, "staffIps")}
                >
                  {s.nombre} {s.apellidos} X
                </span>
              ))}
            </div>
          </div>
          <div className="form-row mt-2">
            <div className="col">
              <span>Fecha de inicio</span>
              <DatePicker
                className="form-control input"
                placeholderText="*Inicio"
                selected={fechaInicio}
                onChange={(date) => setFechaInicio(date)}
                dateFormat="dd MMMM, yyyy"
                isClearable={allowedEdit}
                locale="es"
              />
            </div>
            <div className="col">
              <span>Fecha de solicitud</span>
              <DatePicker
                className="form-control input"
                placeholderText="Solicitud"
                selected={fechaSolicitud}
                onChange={(date) => setFechaSolicitud(date)}
                dateFormat="dd MMMM, yyyy"
                isClearable={allowedEdit}
                locale="es"
              />
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="col">
              <span>Presupuesto solicitado (Impuestos incluidos)</span>
              <input
                type="number"
                className="form-control"
                placeholder=""
                value={presupuestoSolicitado}
                onChange={({ target: { value } }) =>
                  setPresupuestoSolicitado(value)
                }
              />
            </div>
            <div className="col">
              <span>Referencia</span>
              <input
                type="text"
                className="form-control"
                placeholder="Referencia"
                value={referencia}
                onChange={({ target: { value } }) => setReferencia(value)}
              />
            </div>
          </div>
          <div className="form-row mt-4">
            {/* Entidades Coordinadoras */}
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addItem(value, "financiadoras")
                }
              >
                <option value={""}>Seleccionar Entidad Financiadora</option>
                {financiadora?.map((coordinadora) => (
                  <option
                    key={coordinadora.id}
                    value={JSON.stringify(coordinadora)}
                  >
                    {coordinadora.nombre}
                  </option>
                ))}
              </select>
              {chosenFinanciadoraId?.map((coordinadora) => (
                <span
                  key={coordinadora.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3"
                  onClick={() =>
                    removeItem(coordinadora, "financiadoras")
                  }
                >
                  {coordinadora.nombre} X
                </span>
              ))}
            </div>
            {/* Entidades Participantes */}
            <div className="col">
              <select
                className="form-control input"
                value={""}
                onChange={({ target: { value } }) =>
                  addItem(value, "entidadesParticipantes")
                }
              >
                <option value={""}>Seleccionar Entidad Participante</option>
                {entidadesParticipantes?.map((participante) => (
                  <option
                    key={participante.id}
                    value={JSON.stringify(participante)}
                  >
                    {participante.nombre}
                  </option>
                ))}
              </select>
              {chosenEntidadesParticipantes?.map((participante) => (
                <span
                  key={participante.id}
                  style={{ cursor: "pointer" }}
                  className="badge badge-info badge-blue-color mr-1 mt-3"
                  onClick={() =>
                    removeItem(participante, "entidadesParticipantes")
                  }
                >
                  {participante.nombre} X
                </span>
              ))}
            </div>
          </div>
          <div className="form-row mt-4">
            <div className="col">
              <span>Investigador participante externo</span>
              <input
                type="text"
                className="form-control"
                placeholder="Investigador participante externo"
                value={investigadorParticipanteExterno}
                onChange={({ target: { value } }) =>
                  setInvestigadorParticipanteExterno(value)
                }
              />
            </div>

            <div className="col">
              <span>Observaciones</span>
              <input
                type="text"
                className="form-control"
                placeholder="Observaciones"
                value={observaciones}
                onChange={({ target: { value } }) => setObservaciones(value)}
              />
            </div>
          </div>

          <div className="form-row mt-4">
            <div className="col-6">
              <small>Seleccionar Convocatoria</small>
              <select
                className="form-control input"
                value={chosenConvocatoriaId}
                onChange={({ target: { value } }) => {
                  setChosenConvocatoriaId(value);
                }}
              >
                <option>Convocatoria</option>
                {convocatorias?.map(({ id, nombreSubconvocatoria }) => (
                  <option key={id} value={id}>
                    {nombreSubconvocatoria}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="form-row mt-4">
            {" "}
            <div className="col-6">
              <small>Estado</small>
              <select
                className="form-control input"
                value={estado}
                onChange={({ target: { value } }) => {
                  setEstado(value);
                }}
              >
                <option value="">Seleccione un estado</option>
                <option value="Aprobada">Aprobada</option>
                <option value="Denegada">Denegada </option>
                <option value="Pendiente">Pendiente</option>
              </select>
            </div>
          </div>
          <div className="form-row mt-4">
            {" "}
            <div className="col-6">
              <small>Gestionado por?</small>
              <select
                className="form-control input"
                value={gestionadoPor}
                onChange={({ target: { value } }) => {
                  setGestionadoPor(value);
                }}
              >
                <option value="">Seleccione una opción</option>
                <option value="UPV">UPV</option>
                <option value="CSIC">CSIC</option>
                <option value="Otros">Otros</option>
              </select>
            </div>
            <div className="col-6">
              <small>Tipo</small>
              <select
                className="form-control input"
                value={tipo}
                onChange={({ target: { value } }) => {
                  setTipo(value);
                }}
              >
                <option value="">Seleccione un tipo de propuesta</option>
                <option value="Proyecto">Proyecto</option>
                <option value="Contrato">Contrato </option>
                <option value="Otros">Otros</option>
              </select>
            </div>
          </div>

          {(isCreate || allowedEdit) && (
            <>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Texto en español</small>
                  <CKEditor
                    initData={resumenEs}
                    config={editorConfig}
                    onChange={({ editor }) => setResumenEs(editor.getData())}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Texto en inglés</small>
                  <CKEditor
                    initData={resumenEn}
                    config={editorConfig}
                    onChange={({ editor }) => setResumenEn(editor.getData())}
                  />
                </div>
              </div>
              <div className="form-row mt-4">
                <div className="col">
                  <small>Texto en valenciano</small>
                  <CKEditor
                    initData={resumenVa}
                    config={editorConfig}
                    onChange={({ editor }) => setResumenVa(editor.getData())}
                  />
                </div>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
